import { useState, useEffect, useContext } from 'react';
import { getRoleJwt, getJwtFromCookies, isExpiredJwt, removeCookies } from "../module_auth/AuthService"

export function MyPageMenuCP(props) {
    const showMypageMenu = props.showMypageMenu
    if (showMypageMenu) {
        return <li class="nav-item dropdown show" style={{ fontFamily: 'Nanum Gothic' }}>
            <a class="dropdown-toggle nav-link" aria-expanded="true" data-bs-toggle="dropdown">마이페이지</a>
            <div class="dropdown-menu" data-bs-popper="none">
                <a class="dropdown-item pulse animated" href="/mbr_cp_mypage">회원정보</a>
                <a class="dropdown-item pulse animated" href="/job_list_mypage?page=1">등록정보</a>
            </div>
        </li>;
    }
    return "";
}

export function MyPageMenuPV(props) {
    const showMypageMenu = props.showMypageMenu
    if (showMypageMenu) {
        return <li class="nav-item dropdown show" style={{ fontFamily: 'Nanum Gothic' }}>
            <a class="dropdown-toggle nav-link" aria-expanded="true" data-bs-toggle="dropdown">마이페이지</a>
            <div class="dropdown-menu" data-bs-popper="none">
                <a class="dropdown-item pulse animated" href="/mbr_pv_mypage">회원정보</a>
                {/* <a class="dropdown-item pulse animated" href="/person_list_mypage?page=1">등록정보</a> */}
                <a class="dropdown-item pulse animated" href="/talent_list_mypage?page=1">재능등록정보</a>
            </div>
        </li>;
    }
    return "";
}

export function AdminMenuMbr(props) {
    const showMenu = props.showMenu
    if (showMenu) {
        return <li class="nav-item dropdown show" style={{ fontFamily: 'Nanum Gothic' }}>
            <a class="dropdown-toggle nav-link" aria-expanded="true" data-bs-toggle="dropdown">회원관리</a>
            <div class="dropdown-menu" data-bs-popper="none">

                <a class="dropdown-item pulse animated" href="/mbr_cp_reg_by_admin">관리자회원등록</a>
                <a class="dropdown-item pulse animated" href="/change_pwd_by_admin">회원패스워드변경</a>
            </div>
        </li>;
    }
    return "";
}

export function AdminMenuObject(props) {
    const showMenu = props.showMenu
    if (showMenu) {
        return <li class="nav-item dropdown show" style={{ fontFamily: 'Nanum Gothic' }}>
            <a class="dropdown-toggle nav-link" aria-expanded="true" data-bs-toggle="dropdown">오브젝트관리</a>
            <div class="dropdown-menu" data-bs-popper="none">
                <a class="dropdown-item pulse animated" href="/job_list_post_ready">승인대기 기업오브젝트</a>
                <a class="dropdown-item pulse animated" href="/person_list_post_ready">승인대기 개인오브젝트</a>
            </div>
        </li>;
    }
    return "";
}

export function CpIntro(props) {
    const showMenu = !props.showMenu
    if (showMenu) {
        return <li class="nav-item"><a class="nav-link active" href="/cp_intro">회사</a></li>
    }
    return "";
}

export function Info(props) {
    const showMenu = !props.showMenu
    if (showMenu) {
        return <li class="nav-item"><a class="nav-link active" href="/info">이용안내</a></li>
    }
    return "";
}

export function AdminMenu(props) {
    const showMenu = props.showMenu
    if (showMenu) {
        return <li class="nav-item dropdown show" style={{ fontFamily: 'Nanum Gothic' }}>
            <a class="dropdown-toggle nav-link" aria-expanded="true" data-bs-toggle="dropdown">관리자페이지</a>
            <div class="dropdown-menu" data-bs-popper="none">
                <a class="dropdown-item pulse animated" href="/mbr_admin_page">관리자정보</a>
                {/* <a class="dropdown-item pulse animated" href="/mbr_pv_mypage">회원목록</a>
                <a class="dropdown-item pulse animated" href="/mbr_pv_mypage">채용목록</a>
                <a class="dropdown-item pulse animated" href="/mbr_pv_mypage">인재목록</a>*/}
                <a class="dropdown-item pulse animated" href="/news_list_admin?page=1">뉴스목록</a>
                <a class="dropdown-item pulse animated" href="/blog_list_admin?page=1">블로그목록</a>
                <a class="dropdown-item pulse animated" href="/notice_list_admin?page=1">공지사항목록</a>
            </div>
        </li>;
    }
    return "";
}

export function LoginOut(props) {
    function onClick() {
        removeCookies()
    }

    const validatedUser = props.validatedUser
    let loginLink
    if (validatedUser) {
        loginLink = <a class="nav-link active" href="/logIn" onClick={onClick}>로그아웃</a>
    } else {
        // loginLink = <a class="nav-link active" href="/logIn">로그인</a>
        loginLink = ""
    }
    return loginLink;
}

export function Navbar() {
    const [showMypageMenuCP, setShowMypageMenuCP] = useState(false);
    const [showMypageMenuPV, setShowMypageMenuPV] = useState(false);
    const [showAdminMenu, setShowAdminMenu] = useState(false);
    const [validatedUser, setValidatedUser] = useState(false);

    useEffect(() => {
        if (getJwtFromCookies() == undefined || getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())) {
            setShowMypageMenuCP(false)
            setShowMypageMenuPV(false)
            setShowAdminMenu(false)
            setValidatedUser(false)
        } else {
            setValidatedUser(true)
            if (getRoleJwt(getJwtFromCookies()) === "ROLE_CP") {
                setShowMypageMenuCP(true)
                setShowMypageMenuPV(false)
                setShowAdminMenu(false)
            } else if (getRoleJwt(getJwtFromCookies()) === "ROLE_PV") {
                setShowMypageMenuPV(true)
                setShowMypageMenuCP(false)
                setShowAdminMenu(false)
            } else if (getRoleJwt(getJwtFromCookies()) === "ROLE_ADMIN") {
                setShowAdminMenu(true)
                setShowMypageMenuCP(false)
                setShowMypageMenuPV(false)
            }
        }
    }, []);

    return (
        <div>
            <nav class="navbar navbar-dark navbar-expand-xl fixed-top bg-white portfolio-navbar gradient">
                <div class="container"><a class="navbar-brand logo" href="/">G-WORKER</a><button data-bs-toggle="collapse" class="navbar-toggler" data-bs-target="#navbarNav">
                    <span class="visually-hidden">Toggle navigation</span><span class="navbar-toggler-icon"></span></button>
                    <div class="collapse navbar-collapse" id="navbarNav">
                        <ul class="navbar-nav ms-auto">
                            {/* <li class="nav-item"><a class="nav-link active" href="/job_list?page=1">채용정보</a></li> */}
                            <li class="nav-item"><a class="nav-link active" href="/map_home">한인 지도</a></li>
                            <li class="nav-item"><a class="nav-link active" href="/talent_list?page=1">한인 전문가</a></li>
                            {/* <li class="nav-item"><a class="nav-link active" href="/person_list?page=1">인재정보</a></li> */}
                            {/* <li class="nav-item"><a class="nav-link active" href="/mentoring">멘토링</a></li> */}
                            {/* <li class="nav-item"><a class="nav-link active" href="/support">컨설팅</a></li> */}
                            {/* <li class="nav-item"><a class="nav-link active" href="/news_list?page=1">뉴스</a></li> */}
                            <li class="nav-item"><a class="nav-link active" href="/blog_list?page=1">블로그</a></li>
                            {/* <li class="nav-item"><a class="nav-link active" href="/cmty_home">커뮤니티</a></li> */}
                            <li class="nav-item"><a class="nav-link active" href="/notice_list?page=1">공지사항</a></li>

                            {/* foot 영역으로 옮기기
                            <Info showMenu={showAdminMenu}/> */}
                            <MyPageMenuCP showMypageMenu={showMypageMenuCP} />
                            <MyPageMenuPV showMypageMenu={showMypageMenuPV} />
                            <AdminMenuMbr showMenu={showAdminMenu} />
                            <AdminMenuObject showMenu={showAdminMenu} />
                            <AdminMenu showMenu={showAdminMenu} />
                            <li class="nav-item">
                                <LoginOut validatedUser={validatedUser}/>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
}

